module.exports = __webpack_public_path__ + "static/media/info-24px.e562ae20.svg";